export const environment = {
  production: true,
  apiBaseUrl: "https://qrcodes.wahl.website",
  cveSiteUrl: 'https://cve-scanner.wahl.website',
  enableNfc: true,
  enableMarketingEmail: true
};
